module.exports = __webpack_public_path__ + "static/media/img_football_formation.13c02fe9.png";